module.exports = __webpack_public_path__ + "catalog/items/bedroom/double-bed/double-bed.svg";